import React, { useState, useEffect, useRef } from 'react';
import {
  PopupMenu,
  TimePicker
} from 'quantux-ui';
import { css, StyleSheet } from 'aphrodite/no-important';
import { blue, salmon } from '../../theme';

const TODAY = new Date();

const AvailDay = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const [dayStatus, setDayStatus] = useState('');
  const [startHour, setStartHour] = useState(TODAY.getHours());
  const [startMinute, setStartMinute] = useState(TODAY.getMinutes());
  const [endHour, setEndHour] = useState(TODAY.getHours());
  const [endMinute, setEndMinute] = useState(TODAY.getMinutes());

  const shouldUpdate = useRef(false);
  const availMenuRef = useRef();

  // ___ Effects _____________________________________________________
  useEffect(() => {
    if (props.data.status !== dayStatus ||
      props.data.startHour !== startHour ||
      props.data.startMinute !== startMinute ||
      props.data.endHour !== endHour ||
      props.data.endMinute !== endMinute
    ) {
      setDayStatus(props.data.status);
      setStartHour(props.data.startHour);
      setStartMinute(props.data.startMinute);
      setEndHour(props.data.endHour);
      setEndMinute(props.data.endMinute);
    }
  }, [props.data]);

  useEffect(() => {
    if (shouldUpdate.current) {
      shouldUpdate.current = false;
      if (dayStatus === 'available') {
        props.onUpdate(props.dayNumber, {
          status: dayStatus,
          startHour,
          startMinute,
          endHour,
          endMinute
        });
      } else {
        props.onUpdate(props.dayNumber, { status: dayStatus });
      }
    }
  }, [
    dayStatus,
    startHour,
    startMinute,
    endHour,
    endMinute
  ]);

  // ___ Styles ______________________________________________________
  const styles = StyleSheet.create({
    container: {
      background: blue[800],
      ':not(:first-child)': {
        marginTop: '1px'
      }
    },
    dayName: {
      width: '100px',
      minWidth: '100px'
    },
    gridEllipsisMenuContainer: {
      minWidth: '120px',
      background: blue[800]
    },
    gridEllipsisMenuItem: {
      display: 'flex',
      alignItems: 'center',
      height: '40px',
      width: '100%',
      marginTop: '1px',
      paddingLeft: '8px',
      color: '#00A0FF',
      fontSize: '14px',
      background: '#002448',
      fill: '#00A0FF',
      ':not(.disabled):hover': {
        background: '#0066CC',
        color: 'white'
      }
    },
    gridEllipsisMenuItemDisabled: {
      color: '#00A0FF80',
      fill: '#00A0FF80'
    },
    dayStatus: {
      position: 'relative',
      width: '105px',
      minWidth: '105px',
      color: blue[400]
    },
    dayStatusUnAvailable: {
      color: salmon[500]
    }
  });

  return (
    <div className={`fx p-2 ${css(styles.container)}`}>
      <div className={css(styles.dayName)}>
        {props.day}
      </div>
      <div
        className={`ml-2 ${css(styles.dayStatus, dayStatus === 'unavailable' && styles.dayStatusUnAvailable)}`}
        ref={availMenuRef}
      >
        <div
          onClick={() => setShowMenu(true)}
        >
          {dayStatus === 'available' ? 'Available' : 'UnAvailable'}
          <i className='ml-1 fa fa-chevron-down' />
        </div>
        <PopupMenu
          top={25}
          left={0}
          position='absolute'
          zIndex='2501'
          visible={showMenu}
          parent={availMenuRef}
          onOutsideClick={() => {
            setShowMenu(false);
          }}
        >
          <div className={css(styles.gridEllipsisMenuContainer)}>
            {/* Available */}
            <div
              className={css(styles.gridEllipsisMenuItem)}
              onClick={() => {
                setShowMenu(false);
                setDayStatus('available');
                shouldUpdate.current = true;
              }}
            >
              Available
            </div>
            {/* Unavailable */}
            <div
              className={css(styles.gridEllipsisMenuItem)}
              onClick={() => {
                setShowMenu(false);
                setDayStatus('unavailable');
                shouldUpdate.current = true;
              }}
            >
              Unavailable
            </div>
          </div>
        </PopupMenu>
      </div>
      <div
        className='fx ml-2'
        style={{ display: dayStatus === 'unavailable' ? 'none' : '' }}
      >
        <div>
          <TimePicker
            hour={startHour}
            minute={startMinute}
            left={-20}
            noUnderline
            timeFormat='24H'
            timePeriod='AM'
            onChangeTime={(hour, min) => {
              setStartHour(hour);
              setStartMinute(min);
              shouldUpdate.current = true;
            }}
            disableTimeFormat
          />
        </div>
        <div className='ml-2'>
          <TimePicker
            hour={endHour}
            minute={endMinute}
            left={-75}
            noUnderline
            timeFormat='24H'
            timePeriod='AM'
            onChangeTime={(hour, min) => {
              setEndHour(hour);
              setEndMinute(min);
              shouldUpdate.current = true;
            }}
            disableTimeFormat
          />
        </div>
      </div>
    </div>
  );
};

export default AvailDay;
